/**
 * @param {string} value
 * @param {string|{ value: string, label: string }} opt
 * @param {number} i
 * @returns {0|-1}
 */
function getTabIndex(value, opt, i) {
	const val = typeof opt === 'object' ? opt.value : opt;
	if (value) { return value === val ? 0 : -1; }
	return i === 0 ? 0 : -1;
}

/**
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.value
 * @param {Array<string|{ value: string, label: string }>} props.options
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export function Radio({ name, value, options, onChange, className = '' }) {
	return (
		<div className={`radio-group ${className}`} role="radiogroup" aria-label={name}>
			{options.map((opt, i) => {
				const val = typeof opt === 'object' ? opt.value : opt;
				const lbl = typeof opt === 'object' ? opt.label : opt;
				return (
					<label key={val} className="radio-option">
						<input
							type="radio"
							name={name}
							value={val}
							checked={value === val}
							onChange={() => onChange(val)}
							tabIndex={getTabIndex(value, opt, i)}
						/>
						{lbl}
					</label>
				);
			})}
		</div>
	);
}
